(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("dyna-travel-interfaces", [], factory);
	else if(typeof exports === 'object')
		exports["dyna-travel-interfaces"] = factory();
	else
		root["dyna-travel-interfaces"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var IDynaTripRequest_1 = __webpack_require__(2);
exports.ERoundTripType = IDynaTripRequest_1.ERoundTripType;
var IDynaTypes_1 = __webpack_require__(3);
exports.EDynaCompanyType = IDynaTypes_1.EDynaCompanyType;
exports.EDynaPlace = IDynaTypes_1.EDynaPlace;
exports.EDynaSex = IDynaTypes_1.EDynaSex;
exports.EDynaTransport = IDynaTypes_1.EDynaTransport;
exports.EDynaTripClass = IDynaTypes_1.EDynaTripClass;
exports.EDynaTripMeal = IDynaTypes_1.EDynaTripMeal;
exports.EDynaPassengerType = IDynaTypes_1.EDynaPassengerType;
var IDynaTripProposal_1 = __webpack_require__(1);
exports.ETripQualityIndex = IDynaTripProposal_1.ETripQualityIndex;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ETripQualityIndex;
(function (ETripQualityIndex) {
    ETripQualityIndex["BEST"] = "BEST";
    ETripQualityIndex["CHEAP"] = "CHEAP";
    ETripQualityIndex["FAST"] = "FAST";
})(ETripQualityIndex = exports.ETripQualityIndex || (exports.ETripQualityIndex = {}));


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// Request trip interfaces - Encode the user's request to API backend request
Object.defineProperty(exports, "__esModule", { value: true });
var ERoundTripType;
(function (ERoundTripType) {
    ERoundTripType["RETURN"] = "RETURN";
    ERoundTripType["ONE_WAY"] = "ONE_WAY";
    ERoundTripType["MULTI_TRIP"] = "MULTI_TRIP";
})(ERoundTripType = exports.ERoundTripType || (exports.ERoundTripType = {}));


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ENUMS, as types of something
Object.defineProperty(exports, "__esModule", { value: true });
var EDynaTransport;
(function (EDynaTransport) {
    EDynaTransport["COLLECTION"] = "COLLECTION";
    // worldwide
    EDynaTransport["AIRPLANE"] = "AIRPLANE";
    EDynaTransport["FERRY"] = "FERRY";
    EDynaTransport["TRAIN"] = "TRAIN";
    EDynaTransport["REGIONAL_BUS"] = "REGIONAL_BUS";
    EDynaTransport["INTERNATIONAL_BUS"] = "INTERNATIONAL_BUS";
    // urban
    EDynaTransport["CITY_BUS"] = "CITY_BUS";
    EDynaTransport["TRAM"] = "TRAM";
    EDynaTransport["SUBWAY"] = "SUBWAY";
    EDynaTransport["GROUND_TRAIN"] = "GROUND_TRAIN";
    EDynaTransport["BIKE"] = "BIKE";
    EDynaTransport["MOTORBIKE"] = "MOTORBIKE";
    EDynaTransport["SKATE"] = "SKATE";
    EDynaTransport["TAXI"] = "TAXI";
    EDynaTransport["SHARING_CAR"] = "SHARING_CAR";
    EDynaTransport["RENT_CAR"] = "SHARING_CAR";
    // personal
    EDynaTransport["WALK"] = "WALK";
    EDynaTransport["SIGHTSEEING"] = "SIGHTSEEING";
    EDynaTransport["FREE_TIME"] = "FREE_TIME";
    EDynaTransport["SLEEP"] = "SLEEP";
    EDynaTransport["WAIT"] = "WAIT";
})(EDynaTransport = exports.EDynaTransport || (exports.EDynaTransport = {}));
var EDynaPlace;
(function (EDynaPlace) {
    EDynaPlace["ANY"] = "ANY";
    EDynaPlace["TRANSPORT"] = "TRANSPORT";
    EDynaPlace["AIRPORT"] = "AIRPORT";
    EDynaPlace["CITY"] = "CITY";
    EDynaPlace["WAITING_ROOM"] = "WAITING_ROOM";
    EDynaPlace["STATION"] = "STATION";
    EDynaPlace["STOP"] = "STOP";
    EDynaPlace["HOTEL"] = "HOTEL";
    EDynaPlace["MOTEL"] = "MOTEL";
    EDynaPlace["PANSION"] = "PANSION";
    EDynaPlace["APPARTMENT"] = "APPARTMENT";
})(EDynaPlace = exports.EDynaPlace || (exports.EDynaPlace = {}));
var EDynaTripClass;
(function (EDynaTripClass) {
    EDynaTripClass["ECONOMY"] = "ECONOMY";
    EDynaTripClass["BUSINESS"] = "BUSINESS";
    EDynaTripClass["CLASS_A"] = "CLASS_A";
    EDynaTripClass["CLASS_B"] = "CLASS_B";
})(EDynaTripClass = exports.EDynaTripClass || (exports.EDynaTripClass = {}));
var EDynaSex;
(function (EDynaSex) {
    EDynaSex["MALE"] = "MALE";
    EDynaSex["FEMALE"] = "FEMALE";
    EDynaSex["OTHER"] = "OTHER";
})(EDynaSex = exports.EDynaSex || (exports.EDynaSex = {}));
var EDynaTripMeal;
(function (EDynaTripMeal) {
    EDynaTripMeal["ALL"] = "ALL";
    EDynaTripMeal["VEGAN"] = "VEGAN";
})(EDynaTripMeal = exports.EDynaTripMeal || (exports.EDynaTripMeal = {}));
var EDynaPassengerType;
(function (EDynaPassengerType) {
    EDynaPassengerType["ADULT"] = "ADULT";
    EDynaPassengerType["CHILD"] = "CHILD";
    EDynaPassengerType["INFANT"] = "INFANT";
})(EDynaPassengerType = exports.EDynaPassengerType || (exports.EDynaPassengerType = {}));
var EDynaCompanyType;
(function (EDynaCompanyType) {
    EDynaCompanyType["AIRLINE"] = "AIRLINE";
    EDynaCompanyType["AGENT"] = "AGENT";
})(EDynaCompanyType = exports.EDynaCompanyType || (exports.EDynaCompanyType = {}));


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(0);


/***/ })
/******/ ]);
});